import React, { createContext, useState } from "react";

interface GetInPaymentConfirmationActionContextType {  
  count: number;
  setCount: (count: number) => void;
}

export const GetInPaymentConfirmationActionContext = createContext<GetInPaymentConfirmationActionContextType>({
  count: 0,
  setCount: () => {},
});

interface GetInPaymentConfirmationActionProviderProps {
  children: React.ReactNode;
}

export const GetInPaymentConfirmationActionProvider: React.FC<GetInPaymentConfirmationActionProviderProps> = ({
  children,
}) => {  
  const [count, setCount] = useState(0);

  const value = {    
    count,
    setCount,
  };
  return (
    <GetInPaymentConfirmationActionContext.Provider value={value}>      
      {children}
    </GetInPaymentConfirmationActionContext.Provider>
  );
};
